/* eslint-disable react/no-string-refs */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Layout } from 'app/blocks/blocks';
import { ID, withCodes } from 'app/blocks/common/codes';
import { processing, tryCatch } from 'app/blocks/common/decorators';
import * as middlewareCommon from 'app/blocks/middleware/middleware';
import { MainTitle } from 'app/blocks/titles/titles';
import ContentSearch from 'app/pages/search/_advanced/content-search/content_search';
import { Form } from './search_advanced.form';

class ContentSearchForm extends Component {
    static propTypes = {
        articleForm: PropTypes.instanceOf(Form).isRequired,
        codes: PropTypes.shape({}).isRequired,
        jid: PropTypes.string,
        onSearch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        jid: null,
    };

    state = {
        isLoading: true,
    };

    componentDidMount() {
        this.updateJournal();
    }

    componentDidUpdate(prevProps) {
        if (this.props.jid !== prevProps.jid) {
            this.updateJournal();
        }
    }

    @tryCatch
    @processing('isLoading')
    async updateJournal() {
        if (this.props.jid) {
            const journal = await middlewareCommon.product.getJournalById(this.props.jid);
            this.setValue('journalTitle', journal?.name);
        }
    }

    search = () => this.props.onSearch(this.props.articleForm, 'article');

    isSearchEnabled = () =>
        this.props.articleForm?.fields?.doi ||
        (this.props.articleForm?.fields?.editorialRefCode && this.props.articleForm?.fields?.journalTitle);

    setValue = (field, value) => this.props.articleForm?.setValue(field, value);

    onValueChange = (field, value) => {
        this.setValue(field, value);
        // TODO setValue mutates this.props.articleForm. Remove forceUpdate hack
        this.forceUpdate();
    };

    render() {
        const { isLoading } = this.state;
        const { articleForm, codes } = this.props;

        return (
            <div className="col-lg-8 offset-lg-2">
                <div className="MissingArticleDetails-Header">
                    <MainTitle>{codes.SEARCH_CODES.SEARCH.PAGE.title}</MainTitle>
                    <div
                        className="Description"
                        dangerouslySetInnerHTML={{ __html: codes.SEARCH_CODES.SEARCH.PAGE.description }}
                    />
                </div>
                <Layout isLoading={isLoading}>
                    {!isLoading && (
                        <ContentSearch
                            articleForm={articleForm}
                            disabledSearchBtn={!this.isSearchEnabled()}
                            onSearch={this.search}
                            onValueChange={this.onValueChange}
                        />
                    )}
                </Layout>
            </div>
        );
    }
}

export default withCodes(ContentSearchForm, ID.SEARCH_CODES);
